import { render } from "./MatchingDropdown.vue?vue&type=template&id=1ffa8589&scoped=true"
import script from "./MatchingDropdown.vue?vue&type=script&lang=js"
export * from "./MatchingDropdown.vue?vue&type=script&lang=js"

import "./MatchingDropdown.vue?vue&type=style&index=0&id=1ffa8589&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffa8589"]])

export default __exports__